"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _DesignComponents = require("../DesignComponents/DesignComponents");

require("./TaskMultiSelect.scss");

var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));

var _AlertFeedback = _interopRequireDefault(require("../AlertFeedback/AlertFeedback"));

var _CompletedContext = require("../CompletedContext");

var _util = require("../util");

var TaskMultiSelect = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskMultiSelect, _Component);

  var _super = (0, _createSuper2.default)(TaskMultiSelect);

  function TaskMultiSelect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TaskMultiSelect);
    _this = _super.call(this, props);
    _this.state = props.state || {};

    if (!_this.state.initialized) {
      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.completed = false;
      _this.state.selected = [];
      _this.state.indexMap = [];

      for (var i = 0; i < _this.props.data.length; i++) {
        _this.state.indexMap[i] = i;
      }

      if (_this.props.randomize) {
        (0, _util.shuffle)(_this.state.indexMap);
      }
    }

    _this.handleSubmit = _this.handleSubmit.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TaskMultiSelect, [{
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      var _this2 = this;

      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      if (prevstate.selected !== this.state.selected && this.props.instantFeedback) {
        var correctSubmission = true;
        this.props.data.forEach(function (item, i) {
          if (!item.correct && _this2.state.selected.includes(i.toString()) || item.correct && !_this2.state.selected.includes(i.toString())) {
            correctSubmission = false;
          }
        });
        this.setState({
          completed: correctSubmission
        });
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this3.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var temp;
      var index = e.target.value;

      if (this.props.instantFeedback) {
        if (this.props.data[index].correct) {
          this.setState({
            showFeedback: true,
            correctFeedback: this.props.data[index].feedback || this.props.correctFeedback,
            incorrectFeedback: undefined
          });
        } else {
          this.setState({
            showFeedback: true,
            incorrectFeedback: this.props.data[index].feedback || this.props.incorrectFeedback,
            correctFeedback: undefined
          });
          return;
        }
      }

      if (this.state.selected.includes(index)) {
        temp = this.state.selected.filter(function (item) {
          return item !== index;
        }).sort();
      } else {
        temp = this.state.selected.concat([index]).sort();
      }

      this.setState({
        selected: temp
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      var _this4 = this;

      e.preventDefault();
      var correctSubmission = true;
      this.props.data.forEach(function (item, i) {
        if (!item.correct && _this4.state.selected.includes(i) || item.correct && !_this4.state.selected.includes(i)) {
          correctSubmission = false;
        }
      });
      this.setState({
        showFeedback: true,
        completed: correctSubmission,
        correctFeedback: correctSubmission && this.props.correctFeedback,
        incorrectFeedback: !correctSubmission && this.props.incorrectFeedback
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (this.props.prompt === undefined) {
        throw new Error("TaskMultiSelect: prop `prompt` is required for accessibility.");
      }

      return /*#__PURE__*/_react.default.createElement("form", {
        style: {
          display: 'inline-block',
          width: "100%"
        },
        onSubmit: this.handleSubmit,
        className: "task task-multi-select"
      }, /*#__PURE__*/_react.default.createElement(_DesignComponents.CheckboxGroup, {
        label: this.props.prompt
      }, this.props.data.map(function (dataValue, index) {
        var _this5$state$indexMap;

        index = (_this5$state$indexMap = _this5.state.indexMap[index]) !== null && _this5$state$indexMap !== void 0 ? _this5$state$indexMap : index;
        dataValue = _this5.props.data[index];
        return /*#__PURE__*/_react.default.createElement(_DesignComponents.Checkbox, {
          key: index,
          checked: _this5.state.selected.includes(index),
          disabled: _this5.state.completed || _this5.props.instantFeedback && _this5.state.selected.includes(index),
          value: index,
          onChange: function onChange(e) {
            _this5.handleChange({
              target: {
                value: index
              }
            });
          }
        }, dataValue.label);
      })), !this.state.completed && !this.props.instantFeedback && /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        className: "bdg-submit-button",
        type: "submit",
        style: {
          float: "right"
        }
      }, "Submit"), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        correct: this.state.correctFeedback,
        show: this.state.showFeedback && (this.state.correctFeedback || this.state.incorrectFeedback),
        onHide: function onHide() {
          _this5.setState({
            showFeedback: false
          });
        }
      }, this.state.correctFeedback || this.state.incorrectFeedback || "Incorrect."));
    }
  }]);
  return TaskMultiSelect;
}(_react.Component);

exports.default = TaskMultiSelect;
TaskMultiSelect.contextType = _CompletedContext.CompletedContext;